<template>
  <v-col
    style="flex: 0 0 380px"
  >
    <v-hover v-slot="{ hover }">
      <v-card
        color="grey lighten-3"
        rounded="lg"
        :elevation="hover ? 10 : 5"
        class="fill-height overflow-hidden"
        @click="$emit('click')"
      >
        <div class="d-flex flex-column fill-height">
          <div
            style="height: 220px; position: relative"
            class="fill-height d-flex justify-center align-center"
          >
            <img
              v-if="drill.preview_url"
              :src="drill.preview_url"
              style="object-fit: cover; width: 100%; height: 100%"
              @contextmenu.prevent="onContextMenu"
            >
            <v-img
              v-else
              height="220px"
            >
              <template v-slot:placeholder>
                <v-row
                  no-gutters
                  align="center"
                  justify="center"
                  class="fill-height"
                >
                  <v-col cols="auto">
                    <v-icon large>
                      fal fa-court-sport
                    </v-icon>
                  </v-col>
                </v-row>
              </template>
            </v-img>
            <v-chip
              v-if="!drill.is_shared && drill.coach"
              label
              color="grey lighten-3"
              x-small
              style="position: absolute; left: 16px; bottom: 16px"
            >
              {{ drill.coach.first_name }} {{ drill.coach.last_name }}
            </v-chip>
          </div>
          <v-divider />
          <div class="pa-4 grey--text text--darken-2 col">
            <div class="font-weight-medium mb-1">
              {{ drill.name }}
            </div>
            <div
              v-if="drill.coach"
              class="caption mb-3"
              style="-webkit-line-clamp: 4; -webkit-box-orient: vertical; display: -webkit-box; overflow: hidden; width: 100%"
            >
              {{ $t('drill_info.dialog.made_by') }} {{ drill.coach.first_name }} {{ drill.coach.last_name }}
            </div>
            <v-divider class="pa-2 grey--text text--darken-2 col" />
            <div
              class="caption mb-3"
              style="-webkit-line-clamp: 4; -webkit-box-orient: vertical; display: -webkit-box; overflow: hidden; width: 100%"
            >
              {{ drill.description }}
            </div>
          </div>
          <div>
            <v-tooltip
              v-for="tag in resolvedTags"
              :key="'tooltip' + tag.id"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :key="'tag'+tag.id"
                  small
                  class="mx-1 mb-1"
                  style="max-width: 250px"
                  v-bind="attrs"
                  v-on="on"
                >
                  <strong class="mr-2 text-capitalize">{{ tag.tag_id }}:</strong>
                  <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ tag.value }}</span>
                </v-chip>
              </template>
              <span>{{ tag.value }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </v-hover>
  </v-col>
</template>
<script>
import { groupBy } from 'lodash'

export default {
  name: 'DrillCard',
  props: {
    drill: {
      type: Object,
      required: true
    }
  },
  data: () => ({

  }),
  computed: {
    resolvedTags() {
      return Object.values(groupBy(this.drill.tags.filter(t => !t.is_hidden), 'tag_id')).map(tagGroup => {
        return {
          ...tagGroup[0],
          value: tagGroup.map(tg => tg.value).join(', ')
        }
      })
    }
  },
  methods: {
    onContextMenu(e) {
      if (!this.$can('create-shared-drills')) {
        e.preventDefault()
        return
      }

      return true
    }
  }
}
</script>
